<svg #svgRef width="900" height="900">
  <g *ngFor="let day of days; index as key" >
    <rect [attr.x]="(key * 120) + 50" [attr.y]="0" width="120" height="30" [attr.fill]="fillColor" (click)="downloadSvg()" style="sroke-width:1;stroke:rgb(0,0,0)" />
    <text font-size="6pt" [attr.x]="(key * 120) + 56" y="10">{{dayText[day]}}</text>
  </g>

  <g *ngFor="let minute of minutes; index as $index" [attr.visibility]="($index + 1) % 4 == 1 ? 'visible' : 'hidden'" [style.visibility]="($index + 1) % 4 == 1 ? 'visible' : 'hidden'">
    <rect [attr.visibility]="($index + 1) % 4 == 1 ? 'visible' : 'hidden'" [style.display]="($index + 1) % 4 == 1 ? '' : 'none'" [attr.x]="0" [attr.y]="($index * 8) + 30" width="50" height="32" [attr.fill]="fillColor" (click)="changeColor()" style="stroke-width:1;stroke:rgb(0,0,0)"  />
    <text [attr.visibility]="($index + 1) % 4 == 1 ? 'visible' : 'hidden'" [style.display]="($index + 1) % 4 == 1 ? '' : 'none'" [attr.x]="4" [attr.y]="($index * 8) + 40" font-size="6pt">{{minute}}</text>
  </g>

  <g *ngFor="let day of days; index as key" >
    <g *ngFor="let program of programs[key]; index as $index ">
      <rect [attr.x]="(key * 120) + 50" [attr.y]="(program.index * 8) + 30" width="120" [attr.height]="8 * program.data.duration" [attr.fill]="studioColor(program.data.studio)" (click)="changeColor()" [style.fill]="studioColor(program.data.studio)" style="stroke-width:1;stroke:rgb(0,0,0)" />
      <text font-size="6pt" fill="white" [attr.x]="(key * 120) + 55" [attr.y]="(program.index * 8) + 40">{{program.data.text}}</text>

    </g>

  </g>
</svg>